import { type Map } from "immutable";

import { compoundQueryKey } from "../operatorsV2/QuerySpec";
import { type RunnableQuery } from "./RunnableQuery";

/**
 * Returns an array of queries sorted such that each query comes after all its dependencies.
 * Uses a simple topological sort algorithm.
 */
export function topologicallySortQueries(querySpecs: Map<string, RunnableQuery>): RunnableQuery[] {
	const visited = new Set<string>();
	const result: RunnableQuery[] = [];

	const visit = (query: RunnableQuery) => {
		if (visited.has(query.queryKey)) {
			return;
		}
		visited.add(query.queryKey);

		// Visit all dependencies first
		const { subqueries } = query.directReferences();
		if (subqueries.size > 0) {
			for (const contentId of subqueries) {
				const depKey = compoundQueryKey({
					contentId,
					permissionSpec: query.permissionFilter,
				});
				const subquery = querySpecs.get(depKey);
				if (subquery) {
					visit(subquery);
				}
			}
		}

		// Add this query after its dependencies
		if (query) {
			result.push(query);
		}
	};

	// Visit all queries
	for (const query of querySpecs.values()) {
		visit(query);
	}

	return result;
}
